import { apiClient } from "../config/api";
import { filterSubjectsByStandard } from "./PrathmikVibhag/subjectFilter";
import { filterUpperPrimarySubjects } from "./UchchPrathmikVibhag/subjectFilter";
import { filterSecondarySubjects } from "./MadhyamikVibhag/subjectFilter";
import { filterNavodayaSubjectsByStandardVariant } from "./Jawahar_Navodaya_Class_5/subjectFilter";
import { filterNmmsSubjects } from "./NMMS/subjectFilter";

export const getSubjectsByStandard = async (standardIndex) => {
  try {
    const res = await apiClient.get("/subject");
    return filterSubjectsByStandard(res.data, Number(standardIndex));
  } catch (error) {
    console.error("Subject API error:", error);
    return [];
  }
};

export const getNmmsSubjects = async () => {
  try {
    const res = await apiClient.get("/subject");
    const all = Array.isArray(res?.data) ? res.data : [];
    return filterNmmsSubjects(all);
  } catch (error) {
    console.error("NMMS Subject API error:", error);
    return [];
  }
};

export const getNavodayaSubjectsByStandard = async (standardIndex, variant = "jawahar") => {
  try {
    const res = await apiClient.get("/subject");
    const all = Array.isArray(res?.data) ? res.data : [];
    const filtered = filterNavodayaSubjectsByStandardVariant(
      all,
      Number(standardIndex),
      variant
    );
    if (process.env.NODE_ENV !== "production") {
      console.log("[Navodaya] /subject count:", all.length);
      console.log(
        "[Navodaya] filtered ids:",
        (filtered || []).map((s) => s?.id)
      );
      console.log("[Navodaya] sample subject keys:", Object.keys(all?.[0] || {}));
    }
    return filtered;
  } catch (error) {
    console.error("Navodaya Subject API error:", error);
    return [];
  }
};

export const getUpperPrimarySubjectsByStandard = async (
  standardIndex,
  selectedSem
) => {
  try {
    const res = await apiClient.get("/subject");
    return filterUpperPrimarySubjects(res.data, Number(standardIndex), selectedSem);
  } catch (error) {
    console.error("Upper Primary Subject API error:", error);
    return [];
  }
};

export const getSecondarySubjectsByStandard = async (standardIndex, selectedSem) => {
  try {
    const res = await apiClient.get("/subject");
    return filterSecondarySubjects(res.data, Number(standardIndex), selectedSem);
  } catch (error) {
    console.error("Secondary Subject API error:", error);
    return [];
  }
};
